module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('router-view')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-228c6aa0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Device/Device.vue
// module id = 164
// module chunks = 2